import { gql } from 'apollo-boost';
const queryAllClients = `
{
    allClients {
        id
        name
    }
}
`;
const changeClientMutation = gql `
	mutation ($clientId: Int!) {
		changeClient(clientId: $clientId) {
			ok
			message
			client {
				id
				name
			}
		}
	}
`;
export { queryAllClients, changeClientMutation };
